import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=e694d0d8&scoped=true"
import script from "./Tournaments.vue?vue&type=script&lang=js"
export * from "./Tournaments.vue?vue&type=script&lang=js"
import style0 from "./Tournaments.vue?vue&type=style&index=0&id=e694d0d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e694d0d8",
  null
  
)

export default component.exports